// import 'cropperjs/dist/cropper.css';
import Cropper from "cropperjs";

(function () {
    const cropper = {
        el: null,

        init: function () {
            const cropper = document.getElementById("cropper");

            if (!cropper) return;

            this.build(cropper);
        },

        build(cropper) {
            this.el = new Cropper(cropper.getElementsByTagName("img")[0], {
                aspectRatio: 1 / 1,
                viewMode: 1,
                cropBoxMovable: false,
                cropBoxResizable: false,
                guides: false,
                dragMode: "move",
                minContainerWidth: 600,
                minContainerHeight: 600,
            });

            const input = cropper.getElementsByTagName("input")[0];
            input.addEventListener("change", this.file);

            const uploader = document.querySelectorAll("[data-cropper]")[0];
            uploader.addEventListener("click", this.upload);
        },

        file: function (e) {
            var reader = new FileReader();
            reader.onloadend = (e) => cropper.el.replace(e.target.result);
            reader.readAsDataURL(this.files[0]);
        },

        crop(filename = "image") {
            const img = cropper.el.getCroppedCanvas({
                width: 300,
                height: 300,
            });

            if (!img) {
                return null;
            }

            const arr = img.toDataURL().split(",");
            const mime = arr[0].match(/:(.*?);/)[1];
            const suffix = mime.split("/")[1];
            const bstr = atob(arr[1]);

            let n = bstr.length;

            const u8arr = new Uint8Array(n);

            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }

            const file = new File([u8arr], `${filename}.${suffix}`, {
                type: mime,
            });

            return file;
        },

        upload() {
            const url =
                document.querySelectorAll("[data-cropper]")[0].dataset.cropper;
            const request = new FormData();
            request.append("image", cropper.crop());

            fetch(url, {
                method: "POST",
                headers: {
                    Accept: "application/json, text-plain, */*",
                    "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr(
                        "content"
                    ),
                },
                credentials: "same-origin",
                body: request,
            }).then((response) => {
                window.location.replace(
                    window.location.href.replace("create", "index")
                );
            });
        },
    };

    cropper.init();
})();
